import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { jxcService, ISCMJxcSearchFields, ISCMJxcDetail, IStatistics, ISCMJxcDetailRow, ISCMJxcDetailPurchasePin } from "./jxcService";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";


export const useJxcModel = createModel(function () {
    const initStatistics = {
        startNum: 0,
        startAmount: 0,
        warehousingInNum: 0,
        warehousingInAmount: 0,
        warehouseOutNum: 0,
        warehouseOutAmount: 0,
        inventoryNum: 0,
        lastestPriceAmount: 0
    }
    const { warehouseList, shopAndOrg: { shopId, shopType }, setLoadingInfo } = useGlobalModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMJxcSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMJxcDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中行Key值
    const [selectedRow, setSelectedRow] = useState<ISCMJxcDetailRow>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //进销存报表 和 商品明细账 (默认进销存)
    const [jxcOrGoodsDetail, setJxcOrGoodsDetail] = useState<"jxcRecord" | "goodsDetail">("jxcRecord");
    const [descTotal, setDescTotal] = useState<IStatistics>(initStatistics);
    //商品明细
    const [purchasePinData, setPurchasePinData] = useState<ISCMJxcDetailPurchasePin[]>([]);
    const [pinPgCfg, setPinPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const updateSearchParam = (updateParam: ISCMJxcSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? (el.shopId + '||' + el.materialCode) === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as ISCMJxcDetailRow)
    }, [selectedRowKeys])

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
        setJxcOrGoodsDetail("jxcRecord");
    }
    const selectParam = (val: object) => {
        loadData({ pageNum: 1 }, { ...searchParam, ...val })
        if (selectedRow) {
            loadMaterialData({ pageNum: 1 }, { ...searchParam, ...val })
        }
    }
    const loadMaterialData = async (page?: ISearchPage, searchValue: ISCMJxcSearchFields = searchParam) => {
        // let { materialCode, materialName } = selectedRow.find(item => item.id === selectedRowKeys[0]) as { materialName: string; materialCode: string };
        let { materialCode, materialName } = selectedRow
        const { startTime, endTime } = searchValue
        const searchParams = {
            shopId,
            shopType,
            startTime,
            endTime,
            materialCode, materialName,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await jxcService.purchasePin(searchParams);
        const { records, ...pg } = retData;
        setPurchasePinData(records);
        setPinPgCfg(transPgToPagination(pg));
    }
    const loadData = async (page?: ISearchPage, searchValue: ISCMJxcSearchFields = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopType,
            shopId: searchValue.shopId ?? shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await jxcService.page(searchParams);
        // let { retData: Data } = await jxcService.statistics({ ...searchParams, pageSize: -1, warehouseCode: searchParam.warehouseCode ?? warehouseList.map((item: any) => item.value).toString() });
        const { records, ...pg } = retData;
        setDataSource(records.map((e: any) => ({
            ...e,
            id: e.shopId + '||' + e.materialCode
        })));
        setPgCfg(transPgToPagination(pg));
        // loadTotal(searchParams)

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: Data } = await jxcService.statistics({ ...searchParams, pageSize: -1, warehouseCode: searchParam.warehouseCode ?? warehouseList.map((item: any) => item.value).toString() });
        setDescTotal(Data);
    }
    const exportJxcPin = async (searchValue: ISCMJxcSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const searchParams = {
                shopId,
                shopType,
                materialCode: selectedRow.materialCode,
                materialName: selectedRow.materialName,
                // ...searchValue,
                //id: selectedRowKeys.join(),
                pageSize: -1,
                pageNum: 1,
            }
            let result = await jxcService.purchasePinExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    //导出
    const exportJxc = async (searchValue: ISCMJxcSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopType,
                shopId: searchValue.shopId ?? shopId
            };
            const searchParams = {
                ...searchValue,
                ...shopParam,
                id: selectedRowKeys.join(),
                pageSize: -1,
                pageNum: 1,
            }
            let result = await jxcService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<ISCMJxcDetail>()
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        jxcOrGoodsDetail, setJxcOrGoodsDetail,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, exportJxc,
        descTotal, setDescTotal,
        purchasePinData, setPurchasePinData,
        pinPgCfg, setPinPgCfg,
        loadMaterialData,
        selectedRow, setSelectedRow,
        exportJxcPin,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        selectParam
    }
});


